import { render } from "./AddAndCloseTab.vue?vue&type=template&id=7b874c57"
import script from "./AddAndCloseTab.vue?vue&type=script&lang=ts"
export * from "./AddAndCloseTab.vue?vue&type=script&lang=ts"
script.render = render

export default script